export const MEN_POWER_SUPPORT_DESCRIPTION_LINK =
  'https://storage.googleapis.com/imagens-omens/product-sheets/plus-lib-57fedb4e6cbe.pdf'
